import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { Modal } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem } from "../../../utils/config";
import { digitFormat, downloadExcel } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import InfoBox from "../Common/InfoBox";
import NotFound from "../Common/NotFound";
import customSelectStyles from '../SelectStyle';

const { RangePicker } = DatePicker;

const Mt5AccountList = (props) => {
    const dispatch = useDispatch();
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [productPerpage, setProductPerPage] = useState(10)
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [groupEmail, setGroupEmail] = useState('');
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [groupId, setGroupId] = useState('');
    const [loadingEdit, setLoadingEdit] = useState(false)
    const [firstLoad, setFirstLoad] = useState(true);
    const [editModal, setEditModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [sortBy, setSortBy] = useState('date_added');
    const [orderBy, setOrderBy] = useState('DESC');
    const [mt5GroupList, setMt5GroupList] = useState([]);
    let errorsObj = { mt5_group_id: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [statistic, setStatistic] = useState({
        total_mt5_balance: ''
    })
    const [editFormData, setEditFormData] = useState({
        mt5_group_id: '',
    })

    const timerRef = useRef(null);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getList(event.selected + 1)
    }

    useEffect(() => {
        getMt5Group();
        getList();
        setFirstLoad(false);
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            setStatistic({ total_mt5_balance: '' })
            setPageNumber(1);
            getList(1);
        }
    }, [from, to, productPerpage, email, groupId, groupEmail, props.lang, sortBy, orderBy]);

    const handleTimeChange = (e) => {
        const formattedFromDate = e ? dayjs(e[0]).format("YYYY-MM-DD") : '';
        const formattedToDate = e ? dayjs(e[1]).format("YYYY-MM-DD") : '';
        setFrom(formattedFromDate);
        setTo(formattedToDate);
    }

    const setSorting = (field) => {
        setSortBy(field)
        if (orderBy === 'ASC') {
            setOrderBy('DESC');
        } else if (orderBy === 'DESC') {
            setOrderBy('ASC');
        }
    }


    const getMt5Group = () => {
        fetch(api.get_mt5_group, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === "success") {
                    if(responseJson.data){
                        setMt5GroupList(responseJson.data)
                    }
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log('error', responseJson.message)
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const getList = (page = pageNumber) => {
        setLoading(true);
        let url = api.get_mt5_accounts + `?page=${page}`;
        if (productPerpage) {
            url += `&limit=${productPerpage}`
        }
        if (from && to) {
            url += `&date_start=${from}&date_end=${to}`
        }
        if (email) {
            url += `&email_mt5_login=${email}`
        }
        if (groupId) {
            url += `&mt5_group_id=${groupId}`
        }
        if (groupEmail) {
            url += `&group_email_mt5_login=${groupEmail}`
        }
        if (sortBy) {
            url += `&sort_by=${sortBy}&order_by=${orderBy}`
        }
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                if (responseJson.status === "success") {
                    setStatistic(responseJson.data.statistic)
                    setResult(responseJson.data.results);
                    var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                    setTotalResultCount(responseJson.data.total_results)
                    setPageCount(pageCount);
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log("error", responseJson.message);
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(item => {
            let formattedData = {
                "Date": item.date_added ? item.date_added : '-',
                "Name": item.full_name ? item.full_name : item.nick_name,
                "Email": item.email ? item.email : '-',
                "MT5 ID": item.mt5_login ? item.mt5_login : '-',
                "MT5 Password": item.mt5_password ? item.mt5_password : '-',
                "Copy EA MT5 ID": item.mt5_group_name ? item.mt5_group_name : '-',
                "MT5 Group": item.mt5_group_id ? item.mt5_group_id : '-',
                "Copy Trade Lot": item.total_copy_trade_lot ? item.total_copy_trade_lot : '-',
                "Max Lot": item.max_lot ? item.max_lot : '-',
                "MT5 Deposit": item.mt5_deposit ? Number(item.mt5_deposit).toLocaleString('en-US', digitFormat) : '-',
                "MT5 Balance": item.mt5_balance ? Number(item.mt5_balance).toLocaleString('en-US', digitFormat) : '-',
                "Remark": item.is_dummy_account ? "Dummy Account" : '-',
                "Status": item.status ? item.status : '-',
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_mt5_accounts + `?page=${pageCount}&limit=${exportPageSize}`;
                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (email) {
                    url += `&email_mt5_login=${email}`
                }
                if (groupId) {
                    url += `&mt5_group_id=${groupId}`
                }
                if (groupEmail) {
                    url += `&group_email_mt5_login=${groupEmail}`
                }
                if (sortBy) {
                    url += `&sort_by=${sortBy}&order_by=${orderBy}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'mt_account')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });
            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }
    }

    const openEditModal = (data) => {
        let newFormData = { ...editFormData };
        newFormData.mt5_group_id = data.mt5_group_id
        setEditFormData(newFormData);
        setSelectedData(data);
        setEditModal(true);
    }

    const closeEditModal = () => {
        setEditFormData({ mt5_group_id: '' });
        setSelectedData(null);
        setEditModal(false);
    }

    const handleOptionEditSelect = async (e, type) => {
        const { value } = e;
        const newFormData = { ...editFormData };
        newFormData[type] = value;
        setEditFormData(newFormData);
    }

    const updateAccount = () => {
        let check = true;
        let errorMsg = { ...errorsObj };
        let newFormData = { ...editFormData };

        if (!editFormData.mt5_group_id) {
            check = false;
            errorMsg.mt5_group_id = "This field is required.";
        }
        setErrors(errorMsg);
        if (check) {
            setLoadingEdit(true);
            fetch(api.edit_customer_mt5 + `/${selectedData.customer_mt5_id}`, {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang.toLowerCase(),
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
                body: JSON.stringify(newFormData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingEdit(false);
                    if (responseJson.status === 'success') {
                        swal(translate(props.lang, "Success"), responseJson.message, { icon: "success" });
                        getList();
                        closeEditModal();
                    } else {
                        setLoading(false);
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        if (typeof responseJson.data.error === 'object') {
                            let apiErrorMsg = { ...errorsObj };
                            let popupMessage = [];
                            Object.keys(responseJson.data.error).map((key, i) => {
                                apiErrorMsg[key] = responseJson.data.error[key];
                                popupMessage.push(responseJson.data.error[key])
                            })
                            setErrors(apiErrorMsg);
                            swal(translate(props.lang, "Error"), popupMessage.join("\n"), "error");
                        } else {
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                    }
                });
        }
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="infoContainer">
                                <div className="px-md-3 py-md-3 p-2">
                                    <Row className="px-0 mx-0">
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <span className="infoTitle">{translate(props.lang, "MT5 Account List")}</span>
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Total MT5 Amount (Personal)")}
                                                boxValue={statistic && statistic.total_mt5_balance && !groupEmail ? Number(statistic.total_mt5_balance).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Total MT5 Amount (Group)")}
                                                boxValue={statistic && statistic.total_mt5_balance && groupEmail ? Number(statistic.total_mt5_balance).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Personal (Search By Email / MT5 ID)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Group (Search By Email / MT5 ID)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setGroupEmail(e.target.value)}
                                                    value={groupEmail}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <RangePicker
                                            className="w-100 mt-3 mt-md-0 input-transparent"
                                            placeholder={[
                                                translate(props.lang, "From"),
                                                translate(props.lang, "To"),
                                            ]}
                                            onChange={(e) => handleTimeChange(e)}
                                        />
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Result Per Page")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                value={productPerpage && shownItem.find(option => option.value === productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerPage(e ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => exportExcel()} disabled={loadingExcel}>
                                            <span className={`btnText`}>{loadingExcel ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Download Excel")}</span>
                                        </button>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>
                                                <div className="d-flex cursor-pointer" onClick={() => setSorting('date_added')}>
                                                    <span className="pe-2">{translate(props.lang, "Date")}</span>
                                                    {sortBy === 'date_added' ?
                                                        orderBy === 'ASC' ?
                                                            <img src={require('../../../images/icon/asc.svg').default} /> :
                                                            <img src={require('../../../images/icon/desc.svg').default} />
                                                        : <img src={require('../../../images/icon/defaultSort.svg').default} />
                                                    }
                                                </div>
                                            </th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Member Name")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 ID")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Password")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "COPY EA MT5 ID")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Group")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Copy Trade Lot")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Max Lot")}</th>
                                            {/* <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Purchase Package")}</th> */}
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Deposit")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>
                                                <div className="d-flex cursor-pointer" onClick={() => setSorting('balance')}>
                                                    <span className="pe-2">{translate(props.lang, "MT5 Balance")}</span>
                                                    {sortBy === 'balance' ?
                                                        orderBy === 'ASC' ?
                                                            <img src={require('../../../images/icon/asc.svg').default} /> :
                                                            <img src={require('../../../images/icon/desc.svg').default} />
                                                        : <img src={require('../../../images/icon/defaultSort.svg').default} />
                                                    }
                                                </div>
                                            </th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Remark")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "EA Status")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={14}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.date_added ? item.date_added : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.full_name ? item.full_name : item.nick_name}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.email ? item.email : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_login ? item.mt5_login : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_password ? item.mt5_password : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_group_name ? item.mt5_group_name : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_group_id ? translate(props.lang, "MT5 Account") + " " + item.mt5_group_id : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.total_copy_trade_lot ? item.total_copy_trade_lot : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.max_lot ? item.max_lot : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_deposit ? Number(item.mt5_deposit).toLocaleString('en-US', digitFormat) : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_balance ? Number(item.mt5_balance).toLocaleString('en-US', digitFormat) : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.is_dummy_account ? translate(props.lang, "Dummy Account") : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center status ${item.status.toLowerCase()}`}>{translate(props.lang, item.status)}</td>
                                                        <td className={`font-weight-500 font-16 text-white`}>
                                                            <button className="primary-btn py-2 text-center mx-auto px-4" onClick={() => openEditModal(item)}>
                                                                <span className={`btnText`}>{translate(props.lang, "Edit")}</span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={14}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow text-black"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow text-black"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal className="fade" show={editModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeEditModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody'>
                        <div className="px-0 px-md-4">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center mb-3">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Edit MT5 Account")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2 ps-2`}>{translate(props.lang, "Name")}</span>
                                    <div className={`groupLabel-input  mt-1 mb-1`}>
                                        <div className="input-group">
                                            <Input
                                                type="text"
                                                placeholder={translate(props.lang, "Enter Name")}
                                                className="form-control input-transparent py-1 px-3"
                                                name="name"
                                                value={selectedData ? selectedData.full_name ? selectedData.full_name : selectedData.nick_name : ''}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2 ps-2`}>{translate(props.lang, "Email")}</span>
                                    <div className={`groupLabel-input  mt-1 mb-1`}>
                                        <div className="input-group">
                                            <Input
                                                type="text"
                                                placeholder={translate(props.lang, "Enter Email")}
                                                className="form-control input-transparent py-1 px-3"
                                                name="email"
                                                value={selectedData ? selectedData.email : ''}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2 ps-2`}>{translate(props.lang, "Balance")}</span>
                                    <div className={`groupLabel-input  mt-1 mb-1`}>
                                        <div className="input-group">
                                            <Input
                                                type="text"
                                                className="form-control input-transparent py-1 px-3"
                                                name="email"
                                                value={selectedData && selectedData.mt5_package ? Number(selectedData.mt5_package).toLocaleString('en-US', digitFormat) : 0}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2 ps-2`}>{translate(props.lang, "MT5 Group")}</span>
                                    <div className={`input-group-select mt-1 mb-1 ${errors.mt5_group_id ? 'errorBorder' : ''}`}>
                                        <Select
                                            options={
                                                mt5GroupList.length > 0 ? mt5GroupList.map((item, i) => ({ key: i, value: item.mt5_group_id, label: item.group_name })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                            }
                                            placeholder={translate(props.lang, "Select MT5 Group")}
                                            className="input-transparent w-100 text-capitalize"
                                            styles={customSelectStyles}
                                            isSearchable={false}
                                            value={mt5GroupList.filter(option => option.mt5_group_id === editFormData.mt5_group_id).length > 0 ? mt5GroupList.filter(option => option.mt5_group_id === editFormData.mt5_group_id).map((item, i) => ({ key: i, value: item.mt5_group_id, label: item.group_name })) : null}
                                            name="type"
                                            onChange={(e) => handleOptionEditSelect(e, "mt5_group_id")}
                                        />
                                    </div>
                                    <div className="ms-2">
                                        <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.mt5_group_id)}</span>
                                    </div>
                                </Col>

                                <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                    <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => updateAccount()} disabled={loadingEdit}>
                                        <span className={`btnText`}>
                                            {loadingEdit ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Submit")}
                                        </span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Mt5AccountList);